module.exports = {"espace_apres_vente":"Espace après-vente","gerer_vos_retours_produit_et_votre_service_apres_vente":"Gérer vos retours produit et votre service après-vente.","menu":"Menu","accueil":"Accueil","mes_produits":"Mes produits","parametres":"Paramètres","se_deconnecter":"Se déconnecter"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/marketmaker/lang/fr/home/template.lang.json
// module id = /zrn
// module chunks = 1